import * as types from './types';
import { Field } from 'src/config';

export const negate = (
    path: types.FilterPath,
    value: boolean,
): types.FilterNegateAction => {
    return {
        type: types.FILTER_NEGATE,
        path,
        value,
    }
}

export const select = (
    path: types.FilterPath,
    value: boolean,
): types.FilterSelectAction => {
    return {
        type: types.FILTER_SELECT,
        path,
        value,
    }
}

export const addAfter = (
    path: types.FilterPath
): types.FilterAddAfterAction => {
    return {
        type: types.FILTER_ADD_AFTER,
        path
    }
}

export const addBefore = (
    path: types.FilterPath
): types.FilterAddBeforeAction => {
    return {
        type: types.FILTER_ADD_BEFORE,
        path
    }
}

export const remove = (
    path: types.FilterPath
): types.FilterRemoveAction => {
    return {
        type: types.FILTER_REMOVE,
        path
    }
}

export const setLogOp = (
    path: types.FilterPath,
    index: number,
    op: types.LogOp
): types.FilterSetLogOpAction => {
    return {
        type: types.FILTER_SET_LOG_OP,
        path,
        index,
        op
    }
}

export const group = (
    path: types.FilterPath,
): types.FilterGroupAction => {
    return {
        type: types.FILTER_GROUP,
        path,
    }
}

export const explode = (
    path: types.FilterPath,
): types.FilterExplodeAction => {
    return {
        type: types.FILTER_EXPLODE,
        path,
    }
}

export const setOp = (
    path: types.FilterPath,
    op: types.ConditionOp,
): types.FilterSetOpAction => {
    return {
        type: types.FILTER_SET_OP,
        path,
        op,
    }
}

export const setDisabled = (
    value: boolean
): types.FilterSetDisabledAction => {
    return {
        type: types.FILTER_SET_DISABLED,
        value,
    }
}

export const setPath = (
    pathLocation: types.PathLocation,
    attr: string,
    field: Field,
): types.FilterSetPathAction => {
    return {
        type: types.FILTER_SET_PATH,
        pathLocation,
        attr,
        field,
    }
}

export const setFunc = (
    pathLocation: types.PathLocation,
    spec: types.ExpressionFunctionSpec
): types.FilterSetFuncAction => {
    return {
        type: types.FILTER_SET_FUNC,
        pathLocation,
        spec,
    }
}

export const removeFunc = (
    pathLocation: types.PathLocation
): types.FilterRemoveFuncAction => {
    return {
        type: types.FILTER_REMOVE_FUNC,
        pathLocation,
    }
}

export const setLiteral = (
    pathLocation: types.PathLocation,
    value: string
): types.FilterSetLiteralAction => {
    return {
        type: types.FILTER_SET_LITERAL,
        pathLocation,
        value,
    }
}

export const reset = (
): types.FilterResetAction => {
    return {
        type: types.FILTER_RESET,
    }
}

export const setExpression = (
    expression: types.Expression
): types.FilterSetExpressionAction => {
    return {
        type: types.FILTER_SET_EXPRESSION,
        expression,
    }
}
